export const marketingPtBR = {
  // FreeMagnetPage
  'marketing.free.seo.title': 'Quickstart Gratuito',
  'marketing.free.seo.description':
    'Pegue o Quickstart Grymwyrd gratuito — as regras e uma aventura única que você pode rodar hoje à noite. Entre no Crepúsculo.',
  'marketing.free.eyebrow': 'Sua passagem gratuita',
  'marketing.free.heading': 'Entre no Crepúsculo — grátis',
  'marketing.free.subheadLead': 'O',
  'marketing.free.quickstartName': 'Quickstart Grymwyrd',
  'marketing.free.subheadTail':
    '— as regras principais mais uma aventura única que você pode rodar hoje à noite. Nos diga onde enviar.',
  'marketing.free.benefit.rules.title': 'As regras',
  'marketing.free.benefit.rules.body': 'Tudo o que você precisa para jogar, destilado num quickstart.',
  'marketing.free.benefit.oneShot.title': 'Uma aventura única',
  'marketing.free.benefit.oneShot.body': 'Uma aventura de horror pronta para rodar na sua primeira noite.',
  'marketing.free.benefit.livingWorld.title': 'Mundo vivo',
  'marketing.free.benefit.livingWorld.body': 'Conexões com uma enciclopédia, mapas e lançamentos semanais.',
  'marketing.free.playInstead.heading': 'Prefere só jogar?',
  'marketing.free.playInstead.body':
    'Forje seu primeiro personagem e rode um teste solo de 10 minutos — sem compra, sem compromisso.',
  'marketing.free.playInstead.cta': 'Forje um personagem',

  // LeadCaptureForm
  'marketing.leadForm.error.generic': 'Algo deu errado. Tente novamente em breve.',
  'marketing.leadForm.ready': 'Seu Quickstart gratuito está pronto.',
  'marketing.leadForm.downloadCta': 'Baixe seu Quickstart',
  'marketing.leadForm.alsoEmailed': 'Também enviamos o link para sua caixa de entrada.',
  'marketing.leadForm.checkInbox': 'Confira sua caixa de entrada — seu Quickstart gratuito está a caminho.',
  'marketing.leadForm.emailPlaceholder': 'voce@exemplo.com',
  'marketing.leadForm.emailAriaLabel': 'Endereço de email',
  'marketing.leadForm.defaultCta': 'Envie-me o Quickstart',
  'marketing.leadForm.privacyNote':
    'Sem spam — só o Quickstart e um lore ocasional. Desinscreva-se a qualquer momento.',
} as const
